module.exports = "## Core\n\nCore tokens enable global changes and consistency. \n"